// extracted by mini-css-extract-plugin
export default {"filterHeaderWarning":"FilterHeaderWarning_filterHeaderWarning__JmGrI"};